export default class Cart{
    constructor(subtotal=0,total=0,servicios=[],pick={direction:'',location:null},delivery={direction:'',location:null}){
        this.subtotal=subtotal;
        this.total=total;
        this.servicios=servicios;
        this.pick=pick;
        this.delivery=delivery;
    }
}